export enum Stretch {
  Uniform = 'Uniform',
  UniformToFit = 'UniformToFit',
}
